/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  kameleonImg.$inject = ["layoutPaths"];
  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();
